import axios from "axios";
import config from "../config";

const https = require('https');

const agent = new https.Agent({
    rejectUnauthorized: false,
});

const instance = axios.create({
    baseURL: config.WS_BASE_URL,
});

instance.interceptors.request.use(async(config) => {
    config.httpsAgent = agent
    const token = localStorage.getItem("token");
    config.headers.Authorization = token ? token : "";
    config.headers.ContentType = "application/json";
    return config;
});

export const sendTextMessage = async(msg) =>
    await instance.post("whatsapp/send/text", { msg });
